/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    center: PropTypes.bool,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'new']),
};

const defaultProps = {
    ...commonDefaultProps,
    type: 'info',
    center: false,
};

const MessageBox = (props) => {
    const classNames = [
        'c-msg-box',
        props.type ? `c-msg-box--${props.type}` : '',
        props.center ? 'c-msg-box--center' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

MessageBox.propTypes = propTypes;

MessageBox.defaultProps = defaultProps;

export default MessageBox;
